import { useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Box, Button, Typography, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Loading from '@/component/mui/Backdrop';
import { toast } from 'react-toastify';
import { SUCCESS } from '@/lib/common/name-space';
import { packBigNumbers } from '@/lib/BigNumbers';
import Header from '@/component/Header';
import { Card, CardContent, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import OtpDialog from '@/component/otp/OtpDialog';
import { readNameType } from '@/api/bet/read';
import { ResReadNameType } from '@/types';
import { updateAddJackpotPoint } from '@/api/bet/update';

// 잭팟 포인트 입력 타입 정의
interface JackpotPointInputType {
  amount: string;
  type: number;
}

export default function AddJackpotPoint() {
  const [jackpotPoint, setJackpotPoint] = useState<JackpotPointInputType>({ amount: '', type: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpDialogOpen, setIsOtpDialogOpen] = useState(false);
  const [pendingPayload, setPendingPayload] = useState<any>(null);
  const [list, setList] = useState<ResReadNameType[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (list.length > 0) {
      return;
    }
    (async () => {
      const re = await readNameType();
      if (re.status !== SUCCESS) {
        return;
      }
      console.log(re);
      setList(re.data);
    })();
  }, [list]);

  const handleInputChange = (field: 'amount', value: string) => {
    setJackpotPoint((prev) => ({ ...prev, [field]: value }));
  };

  const handleOptionChange = (event: any) => {
    setJackpotPoint((prev) => ({ ...prev, type: event.target.value }));
  };

  const handleOtpSuccess = async () => {
    if (jackpotPoint.type === 0) {
      toast.error('게임 종류를 선택해 주세요.');
      return;
    }
    setIsLoading(true);
    try {
      // OTP 인증 성공 시 잭팟 포인트 생성 진행
      // TODO: 실제 API 호출 함수로 교체 필요
      // const re = await createJackpotPoint(pendingPayload);
      // if (re.status !== SUCCESS) {
      //   toast.error('잭팟 포인트 생성에 실패했습니다.');
      //   return;
      // }
      const re = await updateAddJackpotPoint(pendingPayload);
      if (re.status !== SUCCESS) {
        toast.error('잭팟 포인트 추가 누적에 실패했습니다.');
        return;
      }

      toast.success('잭팟 포인트가 성공적으로 생성되었습니다.');
      // 초기 상태로 리셋
      setJackpotPoint({ amount: '', type: 0 });
      setIsOtpDialogOpen(false);
      setPendingPayload(null);
    } catch (e) {
      console.log(e);
      toast.error('잭팟 포인트 생성 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpClose = () => {
    setIsOtpDialogOpen(false);
    setPendingPayload(null);
  };

  const handleCreate = async () => {
    // 필수 입력값 검증
    if (!jackpotPoint.amount.trim() || jackpotPoint.type === 0) {
      toast.error('모든 필드를 입력해주세요.');
      return;
    }

    // payload 생성 및 OTP 인증 다이얼로그 열기
    const payload = {
      amount: jackpotPoint.amount,
      type: jackpotPoint.type,
    };

    setPendingPayload(payload);
    setIsOtpDialogOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          height: '100vh',
          maxHeight: '100vh',
        }}
      >
        <Card>
          <Header title="잭팟 포인트 추가(잭팟에 사용될 포인트 누적금액 추가)" />
          <Divider />
          <Box mb={2} />
          <CardContent sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
            {/* <Box p={2}>
              <Grid container spacing={3} mb={2}>
                <Grid xs={12}>
                  <Typography variant="h6">잭팟 포인트 추가 누적</Typography>
                </Grid>
              </Grid>
            </Box> */}
            <Box p={2}>
              <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="jackpot-option-label">잭팟 옵션 선택</InputLabel>
                    <Select
                      labelId="jackpot-option-label"
                      id="jackpot-option-select"
                      value={jackpotPoint.type}
                      label="잭팟 옵션 선택"
                      onChange={handleOptionChange}
                      size="small"
                    >
                      {list.map((option: ResReadNameType) => (
                        <MenuItem key={option.type} value={option.type}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid xs={12}>
                  <TextField
                    fullWidth
                    label="포인트"
                    value={jackpotPoint.amount}
                    onChange={(e) => handleInputChange('amount', e.target.value)}
                    placeholder="0"
                    size="small"
                    type="number"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid xs={12}>
                  <Button fullWidth variant="contained" color="primary" onClick={handleCreate}>
                    잭팟 포인트 지급
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Loading isLoading={isLoading} />

      {/* OTP 인증 다이얼로그 */}
      <OtpDialog
        open={isOtpDialogOpen}
        onClose={handleOtpClose}
        onSuccess={handleOtpSuccess}
        title="잭팟 포인트 지급 인증"
        description="잭팟 포인트 지급을 위해 OTP 인증이 필요합니다."
        isLoading={isLoading}
      />
    </>
  );
}
